export const APPOINTMENT_VIEWS = Object.freeze({
  DAY: "day",
  WEEK: "week",
  MONTH: "month",
});

export const DAY_OPTIONS = Object.freeze(
  Array.from({length: 31}, (_, index) => String(index + 1).padStart(2, "0")),
);

export const MONTH_OPTIONS = Object.freeze([
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
]);

export const SCAN_REFRESH_INTERVAL_MS = 5_000;
export const FREE_SLOT_INTERVAL_MINUTES = 15;

export const CALENDAR_INTERVAL = Object.freeze({
  start_time: "2:00",
  end_time: "3:00",
  has_interval: 1,
});
